import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";

export class UpdatePackagesState {
    isUpdatePackagesListFetching: boolean = false;
    updatePackagesList: UpdatePackageInstallationsCount[] = [];
}

export default new UpdatePackagesState();